import { render, staticRenderFns } from "./Prevenzione_Tab7.vue?vue&type=template&id=64797575&scoped=true&"
import script from "./Prevenzione_Tab7.vue?vue&type=script&lang=js&"
export * from "./Prevenzione_Tab7.vue?vue&type=script&lang=js&"
import style0 from "./Prevenzione_Tab7.vue?vue&type=style&index=0&id=64797575&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64797575",
  null
  
)

export default component.exports